import React, { Component } from 'react';
import { ButtonGroup, Button, Card, CardBody, CardHeader, Col, Row, Table } from 'reactstrap';
import TablePaginator from '../../containers/TablePaginator/TablePaginator';
import ListActions from '../../containers/ListActions/ListActions';
import { connect } from 'react-redux';
import { fetchObjs, deleteObj } from '../../actions';
import DownloadActions from '../../containers/DownloadActions/DownloadActions';

const emptyMessage = (<p>Não Existem registros para serem exibidos.</p>);

class TurmaList extends Component {

    state = {
        url: '/turmas'
    }

    componentDidMount() {
        this.props.fetchObjs(this.state.url);
    }

    render() {
        return (
            <div className="animated fadeIn">
                <Row>
                    <Col>
                        <Card>
                            <CardHeader>
                                <Row>
                                    <Col xs="6" sm="6">
                                        <strong>Turmas</strong>
                                    </Col>
                                    <Col xs="6" sm="6" style={{ textAlign: 'right' }}>
                                        <ButtonGroup>
                                            <Button type="button" size="sm" color="primary" onClick={() => this.props.history.push(`${this.state.url}/new`)}>
                                                <i className="fa fa-plus"></i> Novo
                                        </Button>
                                            <DownloadActions body={this.props.turmas.length !== 0 ? this.props.turmas : null} />
                                        </ButtonGroup>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                {this.props.turmas.length === 0 ? emptyMessage : ([
                                    <Table key="table" hover bordered striped responsive size="sm">
                                        <thead key="thead">
                                            <tr key="head">
                                                <th key="id">Código</th>
                                                <th key="descricao">Descrição</th>
                                                <th key="ano">Ano</th>
                                                <th key="catequista">Catequista</th>
                                                <th key="limite">Limite</th>
                                                <th key="catequizando">Catequizandos</th>
                                                <th xs="12" sm="1" key="acoes" className="text-center">Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody key="tbody">
                                            {this.props.turmas.map((turma, i) => {
                                                return (
                                                    <tr key={`tr${turma.ID}`}>
                                                        <td key={`tdId${turma.ID}`} onClick={() => this.props.history.push(`${this.state.url}/${turma.ID}`)}>{turma.ID ? turma.ID : ''}</td>
                                                        <td key={`tdDescription${turma.ID}`} onClick={() => this.props.history.push(`${this.state.url}/${turma.ID}`)}>{turma.DESCRICAO ? turma.DESCRICAO : ''}</td>
                                                        <td key={`tdAno${turma.ID}`} onClick={() => this.props.history.push(`${this.state.url}/${turma.ID}`)}>{turma.ANO ? turma.ANO : ''}</td>
                                                        <td key={`tdCatequista${turma.ID}`} onClick={() => this.props.history.push(`${this.state.url}/${turma.ID}`)}>{turma.catequista && turma.catequista.pessoaFisica && turma.catequista.pessoaFisica.pessoa ? turma.catequista.pessoaFisica.pessoa.NOME : ''}</td>
                                                        <td key={`tdLimite${turma.ID}`} onClick={() => this.props.history.push(`${this.state.url}/${turma.ID}`)}>{turma.LIMITE ? turma.LIMITE : ''}</td>
                                                        <td key={`tdCatequizandos${turma.ID}`} onClick={() => this.props.history.push(`${this.state.url}/${turma.ID}`)}>{turma.matriculas ? turma.matriculas.length : ''}</td>
                                                        <td key={`tdAction${turma.ID}`} ><ListActions {...this.props} {...this.state} id={turma.ID} /></td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>,
                                    <TablePaginator key="tablePaginator" {...this.props} {...this.state} />
                                ])}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        turmas: state.obj.records ? state.obj.records : [],
        meta: state.obj.meta ? state.obj.meta : {}
    }
}

export default connect(mapStateToProps, { fetchObjs, deleteObj })(TurmaList);

